<!-- <script>
    import { translateText } from 'lang'
    import { executeClientToGroup, executeClientAsyncToGroup } from "api/rage";
    import { charName } from 'store/chars'
    import { setView, setPopup } from '../../../data'
    import { addListernEvent } from "api/functions";
    
    export let onSelectedView;

    let page = {
        name: "Материалы",
    };

    let userData = {
        targetName: 0,
        changeName: 0,
        timerIdName: 0,
        Name: 0,
    };

    let materialsCount = 0;
    let selectedAmount = 5000;
    let isLoading = true;
    let isLeader = false;

    import { onMount } from 'svelte';
    onMount(async () => {
        charName.subscribe(value => {
            if (userData.Name !== value) {
                CounterUpdate("Name", value);
            }
        });
        
        await loadMaterialsData();
    });

    const CounterUpdate = (args, value) => {
        if (userData["timerId" + args])
            clearTimeout(userData["timerId" + args]);
        userData["change" + args] = userData[args] > value ? (0 - (userData[args] - value)) : (value - userData[args]);
        userData[args] = value;
        userData["timerId" + args] = setTimeout(() => {
            userData["timerId" + args] = 0;
            userData["change" + args] = 0;
            if (!userData["target" + args]) {
                userData["target" + args] = new CountUp("target" + args, value);
            }
            else
                userData["target" + args].update(value);
        }, !userData["target" + args] ? 0 : 5000)
    }

    const loadMaterialsData = async () => {
        try {
            isLoading = true;
            const result = await executeClientAsyncToGroup('getMaterialsInfo');
            if (result && typeof result === "string") {
                const data = JSON.parse(result);
                materialsCount = data.count || 0;
                console.log("Materials count:", materialsCount); // Для отладки
            }
            
            const settingsResult = await executeClientAsyncToGroup("getSettings");
            if (settingsResult && typeof settingsResult === "string") {
                const settings = JSON.parse(settingsResult);
                isLeader = settings.isLeader || false;
                console.log("Is leader:", isLeader); // Для отладки
            }
            
            isLoading = false;
        } catch (e) {
            console.error('Error loading materials data', e);
            isLoading = false;
        }
    };

    const onOrderMaterials = () => {
        let price = Math.floor((selectedAmount / 5000) * 15000000);
        
        setPopup("Confirm", {
            headerTitle: "Заказ материалов",
            headerIcon: "fractionsicon-materials",
            text: `Заказать ${selectedAmount} материалов за ${(price/1000000).toFixed(0)} млн?`,
            button: 'Заказать',
            callback: () => confirmOrder()
        });
    };

    const confirmOrder = () => {
        executeClientToGroup('orderMaterials', selectedAmount);
        // После заказа обновляем данные
        setTimeout(() => loadMaterialsData(), 1000);
    };

    const onAmountChange = (event) => {
        let value = parseInt(event.target.value);
        if (isNaN(value) || value < 500) value = 500;
        value = Math.round(value / 100) * 100;
        selectedAmount = value;
    };

    const presetAmount = (amount) => {
        selectedAmount = amount;
    };

    // Функция для возврата на главную
    const goBack = () => {
        setView("Main");
    };

    addListernEvent("table.mainInit", loadMaterialsData);
</script>

<div class="app-container">
    <div class="apphead">
        <div class="left">
            <span on:keypress={() => {}} on:click={goBack}>&lt;</span>
            <p>{page.name}</p>
        </div>
        <div class="right">
            <p>{userData.Name}</p>
            <img src="https://cdn.just-rp.online/u90228c5.beget.tech/heone1/ipad/apporg.png" alt=""/>
            <span class="close-btn" on:keypress={() => {}} on:click={() => onSelectedView("mainmenu")}>X</span>
        </div>
    </div>

    <div class="appmenufrac">
        {#if isLoading}
            <div class="loading-container">
                <div class="loader"></div>
                <p>Загрузка данных...</p>
            </div>
        {:else}
            <div class="materials-container">
                <div class="materials-stats">
                    <div class="stat-card">
                        <div class="stat-label">Текущие материалы</div>
                        <div class="stat-value">{materialsCount.toLocaleString()}</div>
                    </div>
                </div>
                
                {#if isLeader}
                    <div class="order-section">
                        <h3>Заказать поставку</h3>
                        <p class="price-info">15 млн за 5000 материалов</p>
                        
                        <div class="amount-presets">
                            <button class="preset-btn" class:active={selectedAmount === 500} on:click={() => presetAmount(500)}>500</button>
                            <button class="preset-btn" class:active={selectedAmount === 1000} on:click={() => presetAmount(1000)}>1000</button>
                            <button class="preset-btn" class:active={selectedAmount === 2500} on:click={() => presetAmount(2500)}>2500</button>
                            <button class="preset-btn" class:active={selectedAmount === 5000} on:click={() => presetAmount(5000)}>5000</button>
                            <button class="preset-btn" class:active={selectedAmount === 10000} on:click={() => presetAmount(10000)}>10000</button>
                        </div>
                        
                        <div class="custom-amount">
                            <input 
                                type="range" 
                                min="500" 
                                max="50000" 
                                step="100"
                                bind:value={selectedAmount}
                            />
                            <div class="amount-input-wrapper">
                                <input 
                                    type="number" 
                                    min="500" 
                                    max="50000" 
                                    step="100"
                                    bind:value={selectedAmount}
                                />
                                <span>материалов</span>
                            </div>
                        </div>
                        
                        <div class="order-total">
                            <div class="total-row">
                                <span>Сумма заказа:</span>
                                <span class="total-price">{Math.floor((selectedAmount / 5000) * 15).toFixed(1)} млн</span>
                            </div>
                        </div>
                        
                        <button 
                            class="order-btn" 
                            on:click={onOrderMaterials}
                        >
                            Заказать поставку
                        </button>
                    </div>
                    
                    <div class="info-message">
                        * После заказа армия получит уведомление и метку на карте
                    </div>
                {:else}
                    <div class="no-access">
                        <p>Только лидер фракции может заказывать материалы</p>
                    </div>
                {/if}
            </div>
        {/if}
    </div>
</div>

<style>
    .app-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #000000;
        color: #fff;
    }

    .apphead {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        background: #0a0a0a;
        border-bottom: 1px solid #1a1a1a;
    }

    .left {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .left span {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #1a1a1a;
        border-radius: 50%;
        cursor: pointer;
        font-size: 18px;
        transition: all 0.2s;
        color: #fff;
    }

    .left span:hover {
        background: #2a2a2a;
    }

    .left p {
        font-size: 20px;
        font-weight: bold;
        margin: 0;
        color: #fff;
    }

    .right {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .right p {
        font-size: 16px;
        color: #ffd700;
        margin: 0;
    }

    .right img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .close-btn {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #330000;
        border-radius: 50%;
        cursor: pointer;
        font-size: 16px;
        transition: all 0.2s;
        color: #ff6b6b;
        margin-left: auto;
    }

    .close-btn:hover {
        background: #550000;
        color: #ff0000;
    }

    .appmenufrac {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
        background: #000000;
    }

    .loading-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }

    .loader {
        width: 50px;
        height: 50px;
        border: 3px solid #1a1a1a;
        border-top-color: #ffd700;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }

    .materials-container {
        height: 100%;
    }
    
    .materials-stats {
        margin-bottom: 25px;
    }
    
    .stat-card {
        background: #0a0a0a;
        border-radius: 8px;
        padding: 20px;
        border: 1px solid #1a1a1a;
    }
    
    .stat-label {
        font-size: 14px;
        color: #888;
        margin-bottom: 8px;
    }
    
    .stat-value {
        font-size: 36px;
        font-weight: bold;
        color: #ffd700;
    }
    
    .order-section {
        background: #0a0a0a;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 15px;
        border: 1px solid #1a1a1a;
    }
    
    .order-section h3 {
        margin: 0 0 5px 0;
        font-size: 18px;
        font-weight: normal;
        color: #fff;
    }
    
    .price-info {
        margin: 0 0 20px 0;
        color: #4caf50;
        font-size: 14px;
    }
    
    .amount-presets {
        display: flex;
        gap: 10px;
        margin-bottom: 20px;
        flex-wrap: wrap;
    }
    
    .preset-btn {
        background: #1a1a1a;
        border: 1px solid #333;
        color: #fff;
        padding: 10px 15px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: all 0.2s;
        flex: 1;
        min-width: 60px;
    }
    
    .preset-btn:hover {
        background: #2a2a2a;
        border-color: #ffd700;
    }
    
    .preset-btn.active {
        background: #332d00;
        border-color: #ffd700;
        color: #ffd700;
    }
    
    .custom-amount {
        margin-bottom: 20px;
    }
    
    .custom-amount input[type="range"] {
        width: 100%;
        margin-bottom: 10px;
        cursor: pointer;
        background: #1a1a1a;
        height: 6px;
        border-radius: 3px;
    }
    
    .custom-amount input[type="range"]::-webkit-slider-thumb {
        background: #ffd700;
        width: 18px;
        height: 18px;
        border-radius: 50%;
    }
    
    .amount-input-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    
    .amount-input-wrapper input {
        background: #1a1a1a;
        border: 1px solid #333;
        color: #fff;
        padding: 10px 12px;
        border-radius: 4px;
        width: 150px;
        font-size: 14px;
    }
    
    .amount-input-wrapper input:focus {
        outline: none;
        border-color: #ffd700;
    }
    
    .amount-input-wrapper span {
        color: #888;
        font-size: 14px;
    }
    
    .order-total {
        background: #000000;
        border-radius: 4px;
        padding: 15px;
        margin-bottom: 20px;
        border: 1px solid #333;
    }
    
    .total-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    
    .total-row span:first-child {
        color: #888;
        font-size: 14px;
    }
    
    .total-price {
        color: #ffd700;
        font-size: 20px;
        font-weight: bold;
    }
    
    .order-btn {
        width: 100%;
        background: #4caf50;
        border: none;
        color: white;
        padding: 15px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.2s;
    }
    
    .order-btn:hover {
        background: #45a049;
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(76, 175, 80, 0.3);
    }
    
    .info-message {
        text-align: center;
        color: #888;
        font-size: 13px;
        margin-top: 10px;
    }
    
    .no-access {
        text-align: center;
        padding: 40px 20px;
        background: #0a0a0a;
        border-radius: 8px;
        border: 1px solid #1a1a1a;
        color: #888;
        font-size: 14px;
    }
</style>-->